// Should link to path
// Add new route to app.js
// make a form to retrieve this password using Firebase
const ForgotPW = () => {
  return (
    <div>ForgotPW</div>
  )
}

export default ForgotPW